export default __webpack_public_path__ + "static/divisa-793fc451b2d4bbf7f5d9537d7692baf0.png";